export const GET_COUNTRIES_LIST = 'lk/countries'
